
<div class="text-center"><i class="fal fa-3x fa-exclamation-triangle text-warning"></i>
  <h3 translate>Page not found</h3>
</div>